// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ModelTrackerOutput } from "./ModelTrackerOutput";
import {
  ModelTrackerOutputFromJSON,
  ModelTrackerOutputFromJSONTyped,
  ModelTrackerOutputToJSON,
  ModelTrackerOutputToJSONTyped,
} from "./ModelTrackerOutput";
import type { ModelTrackerInput } from "./ModelTrackerInput";
import {
  ModelTrackerInputFromJSON,
  ModelTrackerInputFromJSONTyped,
  ModelTrackerInputToJSON,
  ModelTrackerInputToJSONTyped,
} from "./ModelTrackerInput";

/**
 *
 * @export
 * @interface ModelTrackerSchema
 */
export interface ModelTrackerSchema {
  /**
   *
   */
  tag: ModelTrackerSchemaTagEnum;
  /**
   *
   */
  inputs: ModelTrackerInput;
  /**
   *
   */
  outputs: ModelTrackerOutput;
}

/**
 * @export
 */
export const ModelTrackerSchemaTagEnum = {
  ModelTracker: "model_tracker",
} as const;
export type ModelTrackerSchemaTagEnum =
  (typeof ModelTrackerSchemaTagEnum)[keyof typeof ModelTrackerSchemaTagEnum];

/**
 * Check if a given object implements the ModelTrackerSchema interface.
 */
export function instanceOfModelTrackerSchema(value: object): value is ModelTrackerSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "model_tracker") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function ModelTrackerSchemaFromJSON(json: any): ModelTrackerSchema {
  return ModelTrackerSchemaFromJSONTyped(json, false);
}

export function ModelTrackerSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ModelTrackerSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: ModelTrackerInputFromJSON(json["inputs"]),
    outputs: ModelTrackerOutputFromJSON(json["outputs"]),
  };
}

export function ModelTrackerSchemaToJSON(json: any): ModelTrackerSchema {
  return ModelTrackerSchemaToJSONTyped(json, false);
}

export function ModelTrackerSchemaToJSONTyped(
  value?: ModelTrackerSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: ModelTrackerInputToJSON(value["inputs"]),
    outputs: ModelTrackerOutputToJSON(value["outputs"]),
  };
}
